export const API_TYPES = {
  AUTH: "auth",
  ASOCIJATOR: "asocijator",
};

export const API_APP_NAMES = {
  ASOCIJATOR: "express_asocijator",
};
